"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { SITE_NAME, resolvePage } from "@/lib/page-titles";

/**
 * Browser tab title: «اسم الصفحة — مركز الإعلام الذكي», from the same registry
 * as the sidebar and the top bar. Every tab used to read «مركز الإعلام الذكي —
 * لوحة التحكم», so several open tabs could not be told apart.
 */
export default function DocumentTitle() {
  const pathname = usePathname() ?? "/";
  useEffect(() => {
    const page = resolvePage(pathname);
    document.title = page ? `${page.title} — ${SITE_NAME}` : SITE_NAME;
  }, [pathname]);
  return null;
}
